import { Colors } from '@sigma-frontend-libs/commons'

import { balance } from '@/utils'

import render from './render'

export default {
  name: 'ButtonAccount',

  mixins: [ balance() ],

  data() {
    return {
      show: false
    }
  },

  computed: {
    balanceColor() {
      if (this.balance > 0) {
        return Colors.success
      }
      if (this.balance + this.overdraft >= 0) {
        return Colors.warning
      }

      return Colors.error
    }
  },

  render
}
